import React from "react";
import PropTypes from "prop-types";
import * as reactIntl from "react-intl";
import { connect } from "react-redux";
import { compose } from "redux";
import { Button, Toast } from "@ebsco-ui/ebsco-ui";
import sharedMessages from "../../../../shared-messages";
import SubSection from "../sub-section";
import messages from "./data-reports-messages";
import DataReportList from "./data-report-list";

import { FormattedMessage } from "react-intl";

import {
  createDataReport,
  fetchDataReportList,
  createDataReportLoading,
  fetchDataReportListLoading,
  hasPendingDataReports
} from "../../../store/data-report";

const block = "data-reports";

const DataReports = ({
  intl: { formatMessage },
  isLoading,
  dataReportCreation,
  getDataReportList,
  hasPendingReport
}) => {
  const handleSuccess = () => {
    getDataReportList();
    Toast(formatMessage(messages.newReportSuccess), {
      closeButton: false,
      type: "success"
    });
  };

  const handleFailure = () =>
    Toast(formatMessage(sharedMessages.somethingWentWrong), {
      closeButton: false,
      type: "error"
    });

  const handleClick = () =>
    dataReportCreation()
      .then(handleSuccess)
      .catch(handleFailure);

  const submitButtonProps = {
    type: "submit",
    styleType: "solid",
    disabled: isLoading || hasPendingReport,
    onClick: handleClick
  };

  return (
    <SubSection
      className={block}
      headerText={formatMessage(messages.yourReportsAvailable)}
    >
      <DataReportList />
      <Button className={`${block}__submit`} {...submitButtonProps}>
        <FormattedMessage {...messages.requestNewReport} />
      </Button>
    </SubSection>
  );
};

DataReports.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  hasPendingReport: PropTypes.bool.isRequired,
  dataReportCreation: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  isLoading:
    createDataReportLoading(state) || fetchDataReportListLoading(state),
  hasPendingReport: hasPendingDataReports(state)
});

const mapDispatchToProps = {
  dataReportCreation: createDataReport,
  getDataReportList: fetchDataReportList
};

export { DataReports };

export default compose(
  reactIntl.injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(DataReports);
